import styled from 'styled-components';

import { COLORS } from 'constants/colors';
import { FONTS } from 'constants/fonts';

export const ModalOverlay = styled.div`
  position: fixed;
  justify-content: center;
  align-items: center;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
  z-index: 1050;
`;

export const CloseButton = styled.button`
  align-self: flex-end;
  background-color: transparent;
  color: white;
  font-size: ${FONTS.BASE_TEXT_FONT};
  margin-left: 32px;
  margin-top: 24px;
  border: none;
  cursor: pointer;
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

export const MediaWrapper = styled.div`
  display: flex;
  z-index: 1000;
  justify-content: center;
  align-items: center;
  margin-right: 62px;
  margin-left: 62px;
  img,
  video {
    max-width: 1170px;
    max-height: 720px;
    object-fit: contain;
  }
`;

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ArrowButton = styled.div`
  background-color: ${COLORS.Grey14};
  border: 1px solid ${COLORS.Grey14};
  box-shadow: 0px 2px 0px 0px ${COLORS.Grey16};
  border-radius: 21px;
  color: ${COLORS.Grey11};
  padding: 12px;
  cursor: pointer;
  &:first-child {
    margin-right: auto;
  }
  &:last-child {
    margin-left: auto;
  }
`;
